import { render, staticRenderFns } from "./DisqualificationConfirmTable.vue?vue&type=template&id=4a36cd5a&scoped=true"
import script from "./DisqualificationConfirmTable.vue?vue&type=script&lang=js"
export * from "./DisqualificationConfirmTable.vue?vue&type=script&lang=js"
import style0 from "./DisqualificationConfirmTable.vue?vue&type=style&index=0&id=4a36cd5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36cd5a",
  null
  
)

export default component.exports